/* ============================================================
   Sheikh Scents - Motion Library JS (Blox UI port, vanilla)
   - TextScramble        [data-ss-scramble]
   - Scroll reveal       [data-ss-reveal] (+ data-ss-delay="ms")
   - Highlight sweep     .ss-highlight (revealed via observer)
   - Button ripple       .ss-ripple-host (auto-attached)
   - Unified quick add   window.ssQuickAdd (cart drawer refresh
                         + free-shipping progress toast)
   ============================================================ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FREE_SHIPPING_CENTS = 5000; /* $50 threshold */

  /* ---------------- Text scramble ---------------- */
  var SCRAMBLE_CHARS = '!<>-_\\/[]{}=+*^?#ABCDEFGHKMNPQRSTUVWXYZ';

  function scramble(el) {
    if (REDUCED) return;
    if (el.dataset.ssScrambling === '1') return;
    el.dataset.ssScrambling = '1';
    var original = el.dataset.ssText || el.textContent;
    el.dataset.ssText = original;
    var frame = 0;
    var queue = [];
    for (var i = 0; i < original.length; i++) {
      queue.push({
        ch: original[i],
        start: Math.floor(Math.random() * 24),
        end: Math.floor(Math.random() * 24) + 16
      });
    }
    function update() {
      var out = '';
      var done = 0;
      for (var i = 0; i < queue.length; i++) {
        var q = queue[i];
        if (frame >= q.end) { done++; out += q.ch; }
        else if (frame >= q.start) {
          if (q.ch === ' ') { out += ' '; }
          else { out += SCRAMBLE_CHARS[Math.floor(Math.random() * SCRAMBLE_CHARS.length)]; }
        } else { out += ' '; }
      }
      el.textContent = out;
      if (done === queue.length) {
        el.textContent = original;
        el.dataset.ssScrambling = '0';
      } else {
        frame++;
        requestAnimationFrame(update);
      }
    }
    update();
  }

  /* ---------------- Observers ---------------- */
  function initObservers() {
    var revealEls = document.querySelectorAll('[data-ss-reveal]');
    var hlEls = document.querySelectorAll('.ss-highlight:not(.ss-highlight--hover)');
    var scrambleEls = document.querySelectorAll('[data-ss-scramble]');

    if (REDUCED || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('ss-revealed'); });
      hlEls.forEach(function (el) { el.classList.add('ss-revealed'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('ss-revealed');
        if (el.hasAttribute('data-ss-scramble')) scramble(el);
        io.unobserve(el);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(function (el) {
      var delay = el.dataset.ssDelay;
      if (delay) el.style.setProperty('--ss-reveal-delay', delay + 'ms');
      io.observe(el);
    });
    hlEls.forEach(function (el) { io.observe(el); });
    scrambleEls.forEach(function (el) {
      io.observe(el);
      el.addEventListener('click', function () { scramble(el); });
    });
  }

  /* ---------------- Ripple ---------------- */
  function initRipple() {
    if (REDUCED) return;
    var selectors = '.ss-btn--gold, .ss-btn--dark, .ss-btn--outline, .ss-banner__btn, .ss-filter-btn, .ss-product-card__quick-add';
    document.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest(selectors);
      if (!btn) return;
      btn.classList.add('ss-ripple-host');
      var rect = btn.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height);
      var span = document.createElement('span');
      span.className = 'ss-ripple';
      span.style.width = span.style.height = size + 'px';
      span.style.left = (e.clientX - rect.left - size / 2) + 'px';
      span.style.top = (e.clientY - rect.top - size / 2) + 'px';
      btn.appendChild(span);
      setTimeout(function () { span.remove(); }, 650);
    });
  }

  /* ---------------- Free-shipping toast ---------------- */
  var toastTimer = null;
  function showShippingToast(cartTotalCents) {
    var toast = document.getElementById('ssToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'ssToast';
      toast.className = 'ss-toast';
      toast.setAttribute('role', 'status');
      toast.innerHTML =
        '<p class="ss-toast__title">✓ Added to cart</p>' +
        '<p class="ss-toast__msg" id="ssToastMsg"></p>' +
        '<div class="ss-toast__bar"><div class="ss-toast__bar-fill" id="ssToastFill"></div></div>';
      document.body.appendChild(toast);
    }
    var msg = document.getElementById('ssToastMsg');
    var fill = document.getElementById('ssToastFill');
    var pct = Math.min(100, Math.round((cartTotalCents / FREE_SHIPPING_CENTS) * 100));
    if (cartTotalCents >= FREE_SHIPPING_CENTS) {
      msg.textContent = 'Free shipping unlocked.';
    } else {
      var away = ((FREE_SHIPPING_CENTS - cartTotalCents) / 100).toFixed(2);
      msg.textContent = 'You are $' + away + ' away from free shipping';
    }
    requestAnimationFrame(function () {
      toast.classList.add('ss-toast--show');
      fill.style.width = pct + '%';
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('ss-toast--show');
    }, 3500);
  }

  /* ---------------- Unified quick add ---------------- */
  function refreshCartUI(sections) {
    try {
      if (!sections) return;
      var parser = new DOMParser();
      if (sections['cart-drawer']) {
        var drawerEl = document.querySelector('cart-drawer');
        var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        if (drawerEl && fresh) {
          drawerEl.innerHTML = fresh.innerHTML;
          drawerEl.classList.remove('is-empty');
        }
      }
      if (sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        var doc2 = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        var freshBubble = doc2.querySelector('.shopify-section') || doc2.body;
        if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
      }
    } catch (e) { /* non-fatal */ }
  }

  window.ssQuickAdd = async function (btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    var orig = btn.innerHTML;
    btn.innerHTML = '...';
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: 1,
          sections: 'cart-drawer,cart-icon-bubble'
        })
      });
      if (!res.ok) throw new Error('add failed');
      var data = await res.json();
      refreshCartUI(data.sections);
      var cartRes = await fetch('/cart.js');
      var cart = await cartRes.json();
      showShippingToast(cart.total_price);
      btn.innerHTML = 'Added ✓';
      setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 2000);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    } catch (e) {
      btn.innerHTML = 'Error';
      setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 2000);
    }
  };

  /* ---------------- Boot ---------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initObservers();
      initRipple();
    });
  } else {
    initObservers();
    initRipple();
  }
})();